import { render } from "./NavbarButton.vue?vue&type=template&id=06eefffa&scoped=true"
import script from "./NavbarButton.vue?vue&type=script&lang=js"
export * from "./NavbarButton.vue?vue&type=script&lang=js"

import "./NavbarButton.vue?vue&type=style&index=0&id=06eefffa&lang=scss&scoped=true"

import exportComponent from "../../../../../CASRA/saoil/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06eefffa"]])

export default __exports__